import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreams,
} from 'widgets/WidgetRegistry';
import { WidgetSharedStateSection } from 'widgets/store/shared/WidgetsSharedState';
import {
    defaultFillsGraphConfiguration,
    FillsGraphConfiguration,
} from './store/configuration/FillsGraphConfiguration';
import FillsGraph from './FillsGraph';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { fillsGraphDescription } from './description/fillsGraphDescription';
import { fillsGraphWidgetStreamConfig } from 'widgets/fillsGraph/store/data/stream-config';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';

export const fillsGraphWidgetStrategy: WidgetStrategyWithConfig<FillsGraphConfiguration> &
    WidgetStrategyWithStreams = {
    title: 'Fills Graph',
    supportedHosts: ['layout'],
    reactComponentType: FillsGraph,
    initialConfigState: defaultFillsGraphConfiguration,
    sharedStateSections: [WidgetSharedStateSection.ALGORITHM_PARAMETERS],
    categories: [WidgetCategory.SINGLE_STOCK],
    description: fillsGraphDescription,
    streamConfigs: [fillsGraphWidgetStreamConfig],
    getRequiredOrderColumns: () => ['rem', 'fillQty', 'avgPx', 'limit'],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.PositionFromAtLeastOneOrder,
    portfolioSelectionRequirementsWithoutOrdersStream:
        PortfolioSelectionRequirements.SingleSymbolQuantity,
};
